import { SubjectConfig } from '../models/SubjectConfig';

export interface SeriesConfig {
  seriesName: string;
  subjects: SubjectConfig[];
  openingDate: string;
  closingDate: string;
}

export const testSeriesConfig: SeriesConfig[] = [
  {
    seriesName: "Mock Test - 01",
    openingDate: "2026-04-01",
    closingDate: "2026-06-30",
    subjects: [
      { name: "Science", color: "#06B6D4" },
      { name: "English", color: "#FF8C00" },
      { name: "Math", color: "#2563EB" }
    ]
  },
  {
    seriesName: "Mock Test - 02",
    openingDate: "2026-07-01",
    closingDate: "2026-09-30",
    subjects: [
      { name: "Science", color: "#06B6D4" },
      { name: "English", color: "#FF8C00" },
      { name: "Math", color: "#2563EB" }
    ]
  },
  {
    seriesName: "Mock Test - 03",
    openingDate: "2026-10-01",
    closingDate: "2026-12-31",
    subjects: [
      { name: "Science", color: "#06B6D4" },
      { name: "English", color: "#FF8C00" },
      { name: "Math", color: "#2563EB" }
    ]
  }
];

export const liveOlympiadSeriesConfig: SeriesConfig[] = [
  {
    seriesName: "LiveOlympiad Final",
    openingDate: "2026-05-01",
    closingDate: "2026-12-01",
    subjects: [
      { name: "Science", color: "#06B6D4" },
      { name: "English", color: "#FF8C00" },
      { name: "Math", color: "#2563EB" }
    ]
  }
];
